import { type ChangeEvent } from 'react';
import { X } from 'lucide-react';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel: string;
}

export function SearchInput({ value, onChange, placeholder, ariaLabel }: SearchInputProps) {
  return (
    <div className="search-input-wrapper">
      <input
        type="text"
        className="text-input search-input-field"
        placeholder={placeholder}
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        aria-label={ariaLabel}
      />
      {value ? (
        <button
          type="button"
          className="search-input-clear"
          aria-label={`Clear ${ariaLabel}`}
          onClick={() => onChange('')}
        >
          <X size={14} aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
}
